import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to the element matching location.hash (e.g. "#services") on every
 * route or hash change. Scrolls to top when there is no hash.
 *
 * Small delay lets async content (e.g. the fetched catalog) render before the
 * scroll target's final position is known.
 */
export const ScrollToHash = () => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      // Re-try once to account for async-rendered sections
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 400);
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash, pathname]);

  return null;
};
